import { render } from "./Results10.vue?vue&type=template&id=c07ec39c&scoped=true"
import script from "./Results10.vue?vue&type=script&lang=js"
export * from "./Results10.vue?vue&type=script&lang=js"

import "./Results10.vue?vue&type=style&index=0&id=c07ec39c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07ec39c"]])

export default __exports__